export default __webpack_public_path__ + "static/media/faq-screen-shot.46cd1329.png";